<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('customerDeposit.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('customerDeposit.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-items-center ts-justify-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('add_new')
            }}
          </ts-button>
          <div class="ts-flex">
            <div class="ts-w-64">
              <ts-input
                v-model="search"
                :placeholder="$t('customerDeposit.search')"
                style="width: 250px;"
                class="inline-block"
              />
            </div>
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
            <!-- drawer filter date -->
            <a-drawer
              :title="$t('filter')"
              placement="right"
              :closable="false"
              :visible="visible"
              @close="visible = false"
              :zIndex="1020"
              width="300px"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <a-range-picker
                      format="DD-MM-YYYY"
                      :defaultValue="rangeDate"
                      :defaultPickerValue="rangeDate"
                      valueFormat="DD-MM-YYYY"
                      @change="dateRangeChange"
                    >
                      <template slot="renderExtraFooter"></template>
                    </a-range-picker>
                  </div>
                </div>
              </div>
            </a-drawer>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.tran_no }}</td>
            <td>{{ record.customer.customer_name }}</td>
            <td>{{ record.tran_date }}</td>
            <td>{{ record.transaction_type.tran_type }}</td>
            <td class="ts-text-right">{{ record.beginning_balance }}</td>
            <td class="ts-text-right">
              <span class="ts-font-semibold ts-text-green-700">{{ record.amount }}</span>
            </td>
            <td class="ts-text-right">{{ record.ending_balance }}</td>
            <td>{{ record.user.name }}</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <!-- show model create -->
    <a-modal
      :title="$t('customerDeposit.pageTitle')"
      v-if="show_form"
      v-model="show_form"
      width="418px"
      :footer="null"
      :maskClosable="false"
      :centered="true"
      @cancel="cancel"
      :zIndex="1020"
    >
      <frm-create @close="cancel" />
    </a-modal>
  </div>
</template>

<script>
import FrmCreate from './frm_create'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'customerDeposit',
  components: {
    FrmCreate
  },
  data() {
    return {
      show_form: false,
      destroy_modal: false,
      loading: false,
			visible: false,
			rangeDate: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('accounting/customerTopup', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.accounting.customerTopup.search
      },
      set(newValue) {
        this.$store.commit('accounting/customerTopup/SET_SEARCH', newValue)
        this.$store.commit('accounting/customerTopup/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('customerDeposit.tranNo') },
        { name: this.$t('customerDeposit.customerName') },
        { name: this.$t('customerDeposit.tranDate') },
        { name: this.$t('customerDeposit.tranType') },
        {
          name: this.$t('customerDeposit.startBalance'),
          style: 'text-align:right'
        },
        { name: this.$t('customerDeposit.amount'), style: 'text-align:right' },
        {
          name: this.$t('customerDeposit.endingBalance'),
          style: 'text-align:right'
        },
        { name: this.$t('customerDeposit.createdBy') }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('accounting/customerTopup/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    addNew() {
      this.show_form = true
    },
    cancel() {
      this.show_form = false
		},
		dateRangeChange(dateRange) {
      this.$store.commit('accounting/customerTopup/SET_DATE_FROM', dateRange[0])
      this.$store.commit('accounting/customerTopup/SET_DATE_TO',dateRange[1])
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('accounting/customerTopup/RESET_STATE')
    next()
  }
}
</script>